<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox width">
          <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="凭证编码" style="width: 250px">
                <el-input v-model="formInline.BELNR" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="月份" prop="months" style="width: 250px">
                <el-select v-model="formInline.months"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.monthList"
                             :key="item.valut"
                             :label="item.name"
                             :value="item.valut">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="公司" prop="BUKRS">
                <el-select v-model="formInline.BUKRS"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.gongsiList"
                             :key="item.code"
                             :label=" '['+ item.code + ']' + item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称">
                <el-input v-model="formInline.receUsername" placeholder="模糊查询" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户编号">
                <el-input v-model="formInline.receUsercode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30 tableclslist">
        <el-table :data="tableData" style="width: 100%" :border="true" max-height="450" :summary-method="getSummaries" show-summary>
          <el-table-column fixed type="index" label="#" width="60"></el-table-column>
          <el-table-column prop="belnr" label="凭证编号" width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="wrbtr" label="金额" width="80"
                           :show-overflow-tooltip="true">

          </el-table-column>
          <el-table-column prop="bukrs" label="公司代码" width="90" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="receUsername" label="客户名称" :show-overflow-tooltip="true" width="220" ></el-table-column>
          <el-table-column prop="receUsercode" label="客户编码" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column prop="budat" label="凭证过账日期" min-width="120" :formatter="formatDatecc" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="gjahr" label="会计年度" min-width="80" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sgtxt" label="文本" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="formInline" @query="searchReset"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportDetailsExcel()">批量导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";
export default {
  components: {updownfile},
  data() {
    return {
      //表单
      formInline: {
        //月份
        months: null,
        //销售组织
        BUKRS: null,
        //客户编码
        receUsercode: null,
        //客户名称
        receUsername: null,
        //年度
        GJAHR:null,
        //凭证编码
        BELNR:null,
        customerType:'',
        total: 0,
        pageSize: 10,
        pageNo: 1
      },
      tableData:[],
      gongsiList:[],
      monthList:[
        {valut:'01',name:'一月'},
        {valut:'02',name:'二月'},
        {valut:'03',name:'三月'},
        {valut:'04',name:'四月'},
        {valut:'05',name:'五月'},
        {valut:'06',name:'六月'},
        {valut:'07',name:'七月'},
        {valut:'08',name:'八月'},
        {valut:'09',name:'九月'},
        {valut:'10',name:'十月'},
        {valut:'11',name:'十一月'},
        {valut:'12',name:'十二月'},
      ],
    }
  },
  created() {
    this.formInline.customerType = this.$route.query.customerType;
    ss.salesList.getUserAuth().then(response => {
      this.gongsiList = response;
    });
    this.formInline.months = this.$route.query.months;
    this.formInline.GJAHR = this.$route.query.gjahr;
    this.formInline.receUsercode = this.$route.query.receUsercode;
    this.formInline.BUKRS = this.$route.query.bukrs;
    this.searchReset();
  },
  methods: {
    //查询数据
    searchReset(){
      ss.salesList.selectDetailsPage(this.formInline).then(response => {
        this.tableData = response.records;
        this.formInline.total = response.total;
      })
    },
    //重置查询条件
    resetData(){
      this.formInline.BELNR = null;
      this.formInline.BUKRS = this.$route.query.bukrs;
      this.formInline.receUsercode = this.$route.query.receUsercode;
      this.formInline.months = this.$route.query.months;
    },
    //查看详情按钮功能
    seeDetail(v) {
      var url = this.$router.resolve({path: '/payment-details',
        query:{bukrs: v.bukrs, receUsercode: v.receUsercode, months: v.months, gjahr: v.gjahr}});
      window.open(url.href, "_blank");
    },
    //导出
    exportDetailsExcel(){
      updownfile.down("/api/swyl/v1/domestic/userReceDomestic/exportDetailsExcel",this.formInline,"post",'sata');
    },
    //格式化时间
    formatDatecc(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null || data == '') {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        console.log(column,index)
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[1] = '';
          sums[7] = '';
          sums[8] = '';
        } else {
          sums[1] = '';
          sums[3] = '';
          sums[4] = '';
          sums[5] = '';
          sums[6] = '';
          sums[7] = '';
          sums[8] = '';
        }
      });
      return sums;
    },
  }
}
</script>

<style>

</style>
